import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';
import { TimesheetBreakdownRuleService } from '../services/timesheet-breakdown-rule.service';
import { PayCategory } from '../shared/models/pay-category';
import { Position } from '../shared/models/position';
import { IRosterCode } from '../shared/models/roster-code';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';


@Component({
  selector: 'pps-position-dropdown',
  template: `
    <i *ngIf="updating" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <select *ngIf="!updating" [(ngModel)]="selectedBreakdownRule" (change)="onChange($event, selectedBreakdownRule)">
      <option [ngValue]="'1'">If input_hour >= 7.6 then [7.6] else [input_hour]</option>
      <option [ngValue]="'2'">If input_hour < 7.6 then [0] else [input_hour - 7.6]</option>
      <option [ngValue]="'3'">[7.6 hours]</option>
      <option [ngValue]="'4'">[Input hours]</option>
    </select>
  `,
  styles: [
  ],
})
export class BreakdownRuleDropdownComponent implements AgRendererComponent {
  private params: any;
  updating: boolean = false;
  positions: Position[] = [];
  selectedBreakdownRule: string;

  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    let parent = params.context.componentParent;
    this.selectedBreakdownRule = params.data.breakdownRule?.toString();
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(evt, selectedBreakdownRule){
    let parent = this.params.context.componentParent;
    let ruleId = this.params.data.id;
    let foundIndex = parent.rules.findIndex(x => x.id === ruleId);
    if (foundIndex === -1){
      console.log("Something wrong");
      return;
    }
    
    let selectedRule = parent.rules[foundIndex];
    let oldRule = this.params.data.breakdownRule;
    if (selectedBreakdownRule !== oldRule){
      let rule = _.cloneDeep(selectedRule);
      rule.breakdownRule = selectedBreakdownRule * 1;
      this.updating = true;
      parent.updateRule(rule, "break-down-rule", null, null, null, () => this.updating = false);
    }    
  }
}